import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fullscreen: false,
    spotModalShow: false,
    childModalShow: false,
    childModalTitle: "",
    childModalCode: "-1",
    curPageName: "",
    curPageCode: 0,
    koubeiZhishuModalShow:false,
    lvyouyuqingxiangqingShow:false,
    // 模态窗口详情偏移
    childModalOffsetY: 0
  },
  mutations: {
    setFullscreen(state) {
      state.fullscreen = !state.fullscreen;
    },
    setSpotModalShow(state) {
      state.spotModalShow = !state.spotModalShow;
    },
    setKoubeiZhishuModalShow(state) {
      state.koubeiZhishuModalShow = !state.koubeiZhishuModalShow;
    },
    setLvyouyuqingxiangqingShow(state) {
      state.lvyouyuqingxiangqingShow = !state.lvyouyuqingxiangqingShow;
    },
    setChildModalShow(state, val) {
      if(val == false) {
        state.childModalShow = val
        return
      }
      state.childModalShow = !state.childModalShow;
    },
    setChildModalTitle(state, title) {
      state.childModalTitle = title;
    },
    setChildModalCode(state, code) {
      state.childModalCode = code;
    },
    setPageName(state, name) {
      state.curPageName = name;
    },
    setPageCode(state, code) {
      state.curPageCode = code;
    },
    setChildModalOffsetY(state, val) {
      state.childModalOffsetY = val;
    }
  },
  actions: {}
});
